import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('site doelgroepen select')
      // this.initializeToggles()
  }

  // Helper function to get all target IDs from an element
  getTargetIds(element) {
    const targets = []

    // Check for plural data-toggle-targets (space-separated list)
    const multipleTargets = element.getAttribute("data-toggle-targets")
    if (multipleTargets) {
      targets.push(...multipleTargets.split(/\s+/).filter(id => id.length > 0))
    }
    return targets
  }

  // Helper function to toggle elements by IDs
  toggleElements(targetIds, shouldShow) {
    targetIds.forEach(targetId => {
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        if (shouldShow) {
          targetElement.classList.remove("d-none")
        } else {
          targetElement.classList.add("d-none")
        }
      }
    })
  }

  initializeToggles() {
    // Set initial state for checkboxes (support both singular and plural attributes)
    this.element.querySelectorAll('input[type="checkbox"][data-toggle-targets]').forEach(checkbox => {
      this.toggleCheckbox(checkbox)
    })

    // Set initial state for radio buttons
    this.element.querySelectorAll('input[type="radio"][data-toggle-targets]').forEach(radio => {
      if (radio.checked) {
        this.toggleRadio(radio)
      }
    })

    // Set initial state for selects
    this.element.querySelectorAll('select[data-toggle-group]').forEach(select => {
      this.toggleSelect(select)
    })
  }

  handleChange(event) {
    const target = event.target

    if (target.matches('input[type="checkbox"][data-toggle-targets]')) {
      this.toggleCheckbox(target)
    } else if (target.matches('input[type="radio"][data-toggle-targets]')) {
      this.toggleRadio(target)
    } else if (target.matches('select[data-toggle-group]')) {
      this.toggleSelect(target)
    }
  }

  toggleCheckbox(checkbox) {
    const targetIds = this.getTargetIds(checkbox)
    if (targetIds.length > 0) {
      this.toggleElements(targetIds, checkbox.checked)
    }
  }

  toggleRadio(radio) {
    const targetIds = this.getTargetIds(radio)
    const groupName = radio.getAttribute("data-toggle-group")

    if (targetIds.length > 0) {
      // Hide all sections in this group first
      document.querySelectorAll(`input[type="radio"][data-toggle-group="${groupName}"]`).forEach(groupRadio => {
        const groupTargetIds = this.getTargetIds(groupRadio)
        this.toggleElements(groupTargetIds, false)
      })

      // Show the selected sections
      this.toggleElements(targetIds, true)
    }
  }

  toggleSelect(select) {
    // Hide all potential targets for this select
    select.querySelectorAll("option[data-toggle-targets]").forEach(option => {
      const targetIds = this.getTargetIds(option)
      this.toggleElements(targetIds, false)
    })

    // Show selected options' targets
    const selectedOptions = select.multiple ? Array.from(select.selectedOptions) : [select.options[select.selectedIndex]]

    selectedOptions.forEach(option => {
      if (option) {
        const targetIds = this.getTargetIds(option)
        if (targetIds.length > 0) {
          this.toggleElements(targetIds, true)
        }
      }
    })
  }
}
